export default {
    home: "Главная",
    welcome: "Добро пожаловать",
    calendar: "Календарь",
    information: "Информация",
    dictionary: "Словарь",
    searchTerm: "Введите поисковый запрос",
    search: "Искать",
    noSearchResults: "Результаты не найдены",
    writeAnArticle: "Написать статью",
    article: "Статья",
    photo: "Изображение",
    publish: "Опубликовать",
    photoAlbum: "Фотоальбом",
    logout: "Выход",
    ubtzYouthAddress:"Управления дороги АО “УБЖД”, ул. Сеул-42, район Баянгол, город Улан-Батор, 210535, Монголия",
    changeLanguage: "Сменить язык",
  };